var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import CollaboratorStretch from './Model';
import { api } from '../../helpers/Api';
import { action, observable } from 'mobx';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.datas = [];
        this.loading = false;
        this.setData = function (collaboratorStretch) {
            _this.loading = false;
            _this.data = collaboratorStretch ? new CollaboratorStretch(collaboratorStretch) : null;
            return _this.data;
        };
        this.setDatas = function (items) {
            _this.loading = false;
            _this.datas = items.filter(function (item) { return !item.disabled_at; }).map(function (item) { return new CollaboratorStretch(item); });
            return _this.datas;
        };
    }
    default_1.prototype.read = function (value) {
        this.loading = true;
        if (value) {
            return api.post("collaborators/services/operator", value)
                .then(this.setData);
        }
        return api.get("collaborators/services").then(this.setDatas);
    };
    default_1.prototype.updateServiceTIN = function (tin, row_id, stretch_id, operator_id, emails) {
        this.loading = true;
        var data = {
            emails: emails,
            tin: tin,
            row_id: row_id,
            stretch_id: stretch_id,
            operator_id: operator_id
        };
        return api.put("collaborators/services/operator", data).then(this.setData);
    };
    __decorate([
        observable
    ], default_1.prototype, "data", void 0);
    __decorate([
        observable
    ], default_1.prototype, "datas", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loading", void 0);
    __decorate([
        action
    ], default_1.prototype, "updateServiceTIN", null);
    __decorate([
        action
    ], default_1.prototype, "setData", void 0);
    __decorate([
        action
    ], default_1.prototype, "setDatas", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorStretches/Store.ts
// module id = 729
// module chunks = 0